export namespace TRouter {
  export const ROUTE_HOME = `/`;
  export const ROUTE_LOGIN = `/login`;

  export type HashRoute = typeof ROUTE_LOGIN | typeof ROUTE_HOME;
}
